<template>
  <div>
    <myHeader></myHeader>
    <div class="loginBg">
      <div class="loginBox">
        <div class="choseSf">
          <p>请选择身份登录</p>
          <ul>
            <li
              :class="{ active: role == item.dm }"
              v-for="(item, index) in userSf"
              :key="index"
              @click="changeSf(item)"
            >
              {{ item.mc }}
            </li>
          </ul>
        </div>
        <div class="formBox">
          <ul>
            <li
              :class="{ active: activeAccount == item }"
              v-for="(item, index) in accounts"
              :key="index"
              @click="changeAccount(item)"
            >
              {{ item }}
            </li>
          </ul>
          <!-- CA登录 -->
          <div v-show="activeAccount == 'CA登录'">
            <div class="errorMsg">
              <p>{{ errorMsg }}</p>
            </div>
            <div id="ca_login" ref="ca_login"></div>
          </div>
          <!-- 账号登录 -->
          <div v-if="activeAccount == '账号登录'">
            <div class="errorMsg">
              <p>{{ errorMsg }}</p>
            </div>
            <el-input
              class="account"
              v-model.trim="username"
              placeholder="用户名"
            ></el-input>
            <el-input
              class="pin"
              :type="isShowPassword ? 'text' : 'password'"
              v-model.trim="password"
              placeholder="密码"
              @keyup.enter.native="loginZh()"
            >
              <template slot="append">
                <i
                  :class="`icon-view${isShowPassword ? '' : '-close'}`"
                  @click="isShowPassword = !isShowPassword"
                />
              </template>
            </el-input>
            <!-- <div class="verifyImage" v-if="showImageVerify">
              <el-input
                v-model="pictureCode"
                placeholder="图形验证码"
              ></el-input>
              <verify-image
                ref="verifyImage"
              />
            </div> -->
            <el-button
              class="loginBtn"
              type="primary"
              @click="loginZh()"
              :disabled="waitLoading"
              >登录</el-button
            >
          </div>
          <!-- 扫码登录 !!! 暂时删除扫码登录功能 -->
          <!-- <div v-if="activeAccount == '扫码登录'" class="ewm">
            <p style="color:#333">打开<span>E照签APP </span>扫码登录</p>
            <div style="width:160px;height:160px;margin:20px auto;">
              <img
                :src="ewmUrl"
                alt=""
                width="150px"
                height="150px"
                @click="getEwm"
              />
              <div v-if="ewmError" class="ewmMask">
                <p>二维码已失效</p>
                <el-button type="primary" @click="getEwm">请点击刷新</el-button>
              </div>
            </div>
            <p>
              如还未安装E照签APP，请点击<span class="loadApp" @click="loadApp"
                >下载</span
              >
            </p>
          </div> -->
        </div>
      </div>
      <p class="jszc">
        技术支持:浙江招天下招投标交易平台有限公司<span
          >联系电话:400-0571-337</span
        >
      </p>
      <object
        id="USBKeyApi"
        classid="clsid:1246FA8B-41FD-4B45-90B8-47ED9772A1CD"
        style="position: absolute; top: -5000px"
      >
        <embed name="USBKeyApi" type="application/npSOFSignApi-plugin" />
      </object>
    </div>
  </div>
</template>
<script>
import myHeader from "../components/header";
import setting from "@/settings";
// import VerifyImage from '../components/VerifyImage/index.vue'
export default {
  name: "login",
  components: {
    myHeader,
    // VerifyImage
  },
  data() {
    return {
      isShowPassword: false,
      //主持人：有按钮，没列表    招标人/招标代理：没按钮有列表  监管人员：没按钮有列表
      userSf: [],
      role: "Z", //当前角色
      accounts: [],
      activeAccount: "", //当前登录方式
      caList: [], //ca
      username: "",
      pictureCode: "",
      password: "",
      errorMsg: "", //错误提示内容
      getTime: null, //获取二维码定时器
      ewm: null, //验证二维码扫码定时器
      ewmUrl: "", //二维码地址
      ewmError: false, //二维码是否失效
      Ukey: "",
      waitLoading: false,
      showImageVerify: false,
      lock_: null,
      config: {
        select: {
          style: {
            width: "250px",
            backgroundSize: "17px 14px",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "8px center",
          },
          placeholder: "请选择CA证书",
          userCheckRequest: setting.stystemLx,
          userCheckUrl: setting.caCheckUrl,
        },
        detection: {
          name: "检 测",
        },
        pin: {
          style: {
            width: "360px",
            backgroundSize: "13px 21px",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "8px center",
          },
          maxLength: 16,
          placeholder: "请输入CA密码",
        },
        check: {
          name: "立即登录",
          style: {
            width: "360px",
            margin: "0 0 10px 0",
          },
        },
        prompt: {
          text:
            '<p> 1、首次使用CA请先安装<span style="color:#d70a30;cursor: pointer;" id="promptDriverDownload">CA驱动</span>，具体操作见<span style="color:#d70a30;cursor: pointer;">操作手册</span></p>' +
            "<p> 2、如忘记CA密码，请联系服务热线400-0571-337</p>",
          style: {
            width: "360px",
            lineHeight: "20px",
          },
        },
        dialogData: [
          {
            title: "招天下驱动A型",
            type: "A",
          },
          {
            title: "招天下驱动B型",
            type: "B",
          },
          {
            title: "招天下驱动E型",
            type: "E",
          },
        ], //有几个写几个，最多ABC三种
        style: "loginOne",
        certInfoCode: [], // 证书信息 不传默认返回锁的名字,证书序列号,锁的类型
        callback: (res) => {
          if (res.type == "login" && res.state == "succeed") {
            this.loginCa(res.data.currentUser);
          }
        },
        callMessage: {},
      },
    };
  },
  methods: {
    // 切换角色
    changeSf(item) {
      this.role = item.dm;
      this.accounts = item.rolestr.split(",");
      // !!! 暂时删除扫码登录功能
      this.accounts = this.accounts.filter((item) => {
        return item != "扫码登录";
      });
      this.activeAccount = this.accounts[0];
      this.errorMsg = "";
      this.username = "";
      this.password = "";
      clearTimeout(this.getTime);
      this.getTime = null;
      clearTimeout(this.ewm);
      this.ewm = null;
    },
    //切换登录方式
    changeAccount(item) {
      this.activeAccount = item;
      this.errorMsg = "";
      this.username = "";
      this.password = "";
      if (item == "扫码登录") {
        this.getEwm();
      } else {
        clearTimeout(this.getTime);
        this.getTime = null;
        clearTimeout(this.ewm);
        this.ewm = null;
      }
    },
    getRole() {
      let para = {
        lx: 1,
      };
      this.$api
        .getLoginRole(para)
        .then((res) => {
          if (res.data.meta.success) {
            this.userSf = res.data.data.list;
            this.accounts = this.userSf[0].rolestr.split(",");
            // !!! 暂时删除扫码登录功能
            this.accounts = this.accounts.filter((item) => {
              return item != "扫码登录";
            });
            this.activeAccount = this.accounts[0];
            this.$nextTick(() => {
              this.lock_ = new lock();
              this.lock_.init(document.getElementById("ca_login"), this.config);
              let promptDriverDownload = document.getElementById(
                "promptDriverDownload"
              );
              promptDriverDownload.addEventListener("click", () => {
                this.lock_.driverDialogShow(true);
              });
            });
          } else {
            this.$message({
              type: "error",
              message: res.data.meta.message,
            });
          }
        })
        .catch(() => {});
    },
    //获取二维码
    getEwm() {
      clearTimeout(this.getTime);
      this.getTime = null;
      clearTimeout(this.ewm);
      this.ewm = null;
      if (this.activeAccount != "扫码登录") {
        return;
      }
      this.getTime = setTimeout(() => {
        this.getEwm();
      }, 120000);
      this.$api
        .getLoginEwm()
        .then((res) => {
          if (res.data.meta.success) {
            this.ewmUrl = "data:image/gif;base64," + res.data.data.picdata;
            this.uuid = res.data.data.uuid;
            this.setSrcLogin();
          } else {
            clearTimeout(this.ewm);
            this.ewm = null;
          }
        })
        .catch(() => {});
    },
    //验证扫描二维码是否成功
    setSrcLogin() {
      clearTimeout(this.ewm);
      this.ewm = null;
      if (this.activeAccount != "扫码登录") {
        return;
      }
      this.ewm = setTimeout(() => {
        this.setSrcLogin();
      }, 2000);
      let para = {
        uuid: this.uuid,
      };
      this.$api
        .setSrcLogin(para)
        .then((res) => {
          if (res.data.data != null && res.data.data != "") {
            clearTimeout(this.ewm);
            this.ewm = null;
            let para = {
              username: res.data.data.dataMap.jgmc,
              cert: res.data.data.dataMap.cert,
              role: this.role,
            };
            this.$api
              .ewmLogin(para)
              .then((res) => {
                if (res.data.meta.success) {
                  localStorage.setItem("user", res.data.data.qymc);
                  localStorage.setItem("jgdm", res.data.data.jgdm);
                  localStorage.setItem("role", this.role);
                  this.$router.push("/kbxmList");
                } else {
                  this.$message.error(res.data.meta.message);
                }
              })
              .catch(() => {});
          } else {
          }
        })
        .catch(() => {});
    },
    //下载App
    loadApp() {
      window.open(
        "http://zhaotx.cn/product.htm?type=e%D5%D5%C7%A9%C6%BD%CC%A8%BD%E9%C9%DC"
      );
    },
    //账号登录
    loginZh() {
      let para = {
        username: this.username,
        password: this.password,
        role: this.role,
        // pictureCode: 'j49fe', // 默认校验码
        // uniString: '795873489578439' // 默认随机串
      };
      // if (this.showImageVerify) {
      //   para.pictureCode = this.pictureCode
      //   para.uniString = this.$refs.verifyImage.getRandomCode()
      // }
      this.waitLoading = true;
      this.$api
        .loginZh(para)
        .then((res) => {
          if (res.data.meta.success) {
            localStorage.setItem("user", res.data.data.qymc);
            localStorage.setItem("jgdm", res.data.data.jgdm);
            localStorage.setItem("role", this.role);
            if (this.role == "M") {
              this.$router.push("/adminIndex");
            } else {
              this.$router.push("/kbxmList");
            }
          } else {
            console.log(res);
            this.errorMsg = res.data.meta.message;
            // if (!this.showImageVerify) this.showImageVerify = true
          }
          this.waitLoading = false;
        })
        .catch((err) => {
          // if (!this.showImageVerify) this.showImageVerify = true
          this.errorMsg = err.data;
          this.waitLoading = false;
          this.$message({
            message: "请求出错",
            type: "error",
          });
        });
    },
    //ca登录
    loginCa(res) {
      document.getElementsByClassName("submit")[0].innerHTML = "登陆中...";
      let para = {
        username: res.code,
        role: this.role,
      };
      this.waitLoading = true;
      this.$api
        .loginCa(para)
        .then((res) => {
          if (res.data.meta.success) {
            localStorage.setItem("user", res.data.data.qymc);
            localStorage.setItem("jgdm", res.data.data.jgdm);
            localStorage.setItem("role", this.role);
            document.getElementsByClassName("submit")[0].innerHTML = "登陆成功";
            this.$router.push("/kbxmList");
          } else {
            this.errorMsg = res.data.meta.message;
          }
          this.waitLoading = false;
          document.getElementsByClassName("submit")[0].innerHTML = "立即登录";
        })
        .catch(() => {
          this.$message({
            message: "请求出错",
            type: "error",
          });
          this.waitLoading = false;
          document.getElementsByClassName("submit")[0].innerHTML = "立即登录";
        });
    },
  },
  mounted() {
    this.getRole();
    clearTimeout(this.getTime);
    this.getTime = null;
    clearTimeout(this.ewm);
    this.ewm = null;
  },
  beforeDestroy() {
    clearTimeout(this.getTime);
    this.getTime = null;
    clearTimeout(this.ewm);
    this.ewm = null;
  },
};
</script>
<style lang="less">
.loginBg {
  position: relative;
  height: calc(~"100% - 80px");
  min-height: 500px;
  background: url("../assets/images/bg.png") no-repeat center center;
  background-size: cover;
  .jszc {
    position: absolute;
    bottom: 0;
    right: 0;
    color: #fff;
    height: 34px;
    line-height: 34px;
    border-radius: 17px 0 0 0;
    padding: 0 20px;
    background: fade(@base-color, 70%);
    span {
      margin-left: 20px;
    }
  }
  .loginBox {
    height: 410px;
    width: 640px;
    position: absolute;
    top: 50%;
    left: 50%;
    //transform: translate(-50%, -60%);
    margin-top: -205px;
    margin-left: -320px;
    box-shadow: 0 3px 7px rgba(00, 00, 00, 0.35);
    .choseSf {
      width: 180px;
      height: 100%;
      background: @base-color;
      float: left;
      padding-top: 40px;
      padding-left: 30px;
      color: #fff;
      p {
        border-bottom: 1px solid #fff;
        position: relative;
        font-size: 16px;
        font-weight: bold;
        line-height: 28px;
        padding-left: 5px;
      }
      p:before {
        content: "";
        display: inline-block;
        width: 5px;
        height: 5px;
        border-radius: 50%;
        background: #fff;
        position: absolute;
        bottom: -3px;
        left: -1px;
      }
      > ul {
        margin-top: 25px;
        li {
          border: 1px solid #fff;
          border-right: none;
          text-align: left;
          height: 40px;
          line-height: 40px;
          width: 130px;
          float: right;
          padding-left: 30px;
          margin: 5px 0;
          cursor: pointer;
        }
        li.active {
          font-weight: bold;
          background: #fff;
          color: @base-color;
          position: relative;
        }
        li.active:after {
          content: "";
          display: block;
          position: absolute;
          right: -2px;
          top: -2px;
          height: 40px;
          width: 1px;
          box-shadow: -2px 0 3px rgba(00, 00, 00, 0.35);
        }
      }
    }
    .formBox {
      width: 460px;
      height: 100%;
      background: #fff;
      float: left;
      > ul {
        border-bottom: 1px solid #ddd;
        margin-bottom: 15px;
        padding-left: 35px;
        padding-top: 30px;
        height: 80px;
        li {
          float: left;
          padding: 0 30px 0;
          font-size: 18px;
          line-height: 48px;
          color: #333;
          cursor: pointer;
        }
        li.active {
          font-weight: bold;
          color: @base-color;
          border-bottom: 2px solid @base-color;
        }
      }
      > div {
        padding: 0 40px;
        .errorMsg {
          height: 20px;
          p {
            background: url("../assets/images/error.jpg") no-repeat 10px center;
            color: @base-color;
            font-size: 12px;
            padding-left: 30px;
          }
        }
        > div {
          margin-top: 15px;
          button {
            height: 45px;
            line-height: 45px;
            padding: 0;
            width: 100px;
            margin-left: 10px;
          }
        }
        input {
          height: 45px;
          line-height: 45px;
        }
        .caId input {
          padding-left: 40px;
          background: url("../assets/images/ca.jpg") no-repeat 10px center;
          width: 270px;
        }
        .pin input {
          padding-left: 40px;
          background: url("../assets/images/pin.jpg") no-repeat 13px center;
        }
        .account input {
          padding-left: 40px;
          background: url("../assets/images/account.jpg") no-repeat 13px center;
        }
        .loginBtn {
          width: 100%;
          height: 50px;
          line-height: 50px;
          padding: 0;
          font-size: 16px;
          margin-top: 25px;
        }
      }
      div.ewm {
        text-align: center;
        color: #666;
        > div {
          position: relative;
        }
        .ewmMask {
          position: absolute;
          top: 0;
          left: 0;
          bottom: 0;
          right: 0;
          background: @mask-bg;
          p {
            color: #fff;
            font-weight: bold;
            margin-top: 50px;
            margin-bottom: 10px;
          }
        }
        p span {
          color: @base-color;
        }
        p span.loadApp {
          cursor: pointer;
        }
      }
    }
  }
  .verifyImage {
    display: grid;
    grid-template-columns: 65% 30%;
    grid-gap: 15px;
    .btn-imgVerify {
      height: 42px;
    }
    input {
      padding-left: 40px;
      background: url("../assets/images/txyzm.jpg") no-repeat 12px center;
      background-size: 18px;
    }
  }
}
</style>
